import * as types from "./types";
const persistedState = localStorage.getItem("iam");
let defaultState = {
  accessToken: "",
  refreshToken: "",
  loading: false
};
if (persistedState) {
  defaultState = JSON.parse(persistedState);
}

const iam = (state = defaultState, action) => {
  switch (action.type) {
    case types.REQUESTING_AUTH:
      return {
        ...state,
        loading: action.loading
      };
    case types.RECEIVED_AUTH:
      return {
        ...state,
        loading: action.loading,
        accessToken: action.accessToken,
        refreshToken: action.refreshToken
      };
    case types.ERROR_REQUESTING_AUTH:
      return {
        ...state,
        loading: action.loading,
        accessToken: "",
        refreshToken: ""
      };
    case types.REFRESHING_TOKEN:
      return {
        ...state,
        accessToken: action.accessToken,
        loading: action.loading
      };
    case types.REFRESHED_TOKEN:
      return {
        ...state,
        accessToken: action.accessToken,
        loading: action.loading
      };
    case types.LOGOUT:
      return {
        ...state,
        accessToken: action.accessToken,
        refreshToken: action.refreshToken,
        loading: false
      };
    case types.CREATING_ACCOUNT:
      return {
        ...state,
        loading: action.loading
      };
    case types.CREATED_ACCOUNT:
      return {
        ...state,
        loading: action.loading
      };
    case types.ERROR_CREATING_ACCOUNT:
      return {
        ...state,
        loading: action.loading
      };
    default:
      return state;
  }
};

export default iam;
